import React, { FunctionComponent } from "react";
import { Typography, Box, SvgIcon } from "@mui/material";
import {
  GridColDef,
  GridColumnHeaderParams,
  GridRenderCellParams,
} from "@mui/x-data-grid";
import { CustomDataGrid } from "../CustomDataGrid";
import jsonObj from "./obj.json";
import SearchOffIcon from "@mui/icons-material/SearchOff";

const defaultColumnOptions: Partial<GridColDef> = {
  resizable: false,
  flex: 1,
  hideSortIcons: false,
  disableColumnMenu: false,
};

export const LegacyReportGrid: FunctionComponent<{
  rows: any[];
  pageSize: number;
  page: number;
  onChangePageSize: (newPageSize: number) => void;
  onChangePage: (newIndex: number) => void;
}> = (props) => {
  if (props.rows[0] === undefined) {
    return (
      <Box>
        <Box mt={6}>
          <SvgIcon fontSize="large">
            <SearchOffIcon />
          </SvgIcon>
        </Box>
        <Typography>There's no data matching the selected criteria</Typography>
      </Box>
    );
  }

  const keys = Object.keys(props.rows[0]);

  const columns: GridColDef[] = keys.map((key, index) => {
    return {
      field: key,
      headerName: key,
      width: 1000,
      renderHeader: (params: GridColumnHeaderParams) => {
        return (
          <Typography sx={{ fontSize: "14px", fontWeight: 600 }}>
            {params.colDef.headerName!}
          </Typography>
        );
      },
      renderCell: (params: GridRenderCellParams) => {
        return (
          <Typography sx={{ fontWeight: 600, fontSize: 14 }}>
            {params.value}
          </Typography>
        );
      },
      ...defaultColumnOptions,
    };
  });

  return (
    <CustomDataGrid
      columns={props.rows.length ? columns : []}
      rows={props.rows.length ? props.rows : []}
      pagination
      paginationMode="server"
      pageSize={props.pageSize}
      page={props.page}
      onPageChange={props.onChangePage}
      onPageSizeChange={props.onChangePageSize}
      sortingOrder={["asc", "desc"]}
    />
  );
};
